const PURCHASE_VARIANTS = Object.freeze({
  default: 'default',
  lowCredit: 'lowCreditWarning',
});

export default PURCHASE_VARIANTS;

export const UK_BUNDLES = (t) => [
  {
    id: '1',
    label: t('composite.purchaseSmsCreditDialog.bundles.small'),
    smsValue: 50,
    name: 'fifty',
    text: '150',
    smsCost: 3.5,
    smsCostWithoutVat: 3.0,
    smsCostIncVat: 4.2, // inc VAT
    checked: false,
  },
  {
    id: '2',
    label: t('composite.purchaseSmsCreditDialog.bundles.medium'),
    smsValue: 500,
    name: 'five_hundreds',
    text: '1500',
    smsCost: 35.0,
    smsCostWithoutVat: 30.0,
    smsCostIncVat: 42.0, // inc VAT
    checked: false,
  },
  {
    id: '3',
    label: t('composite.purchaseSmsCreditDialog.bundles.large'),
    smsValue: 2000,
    name: 'two_thousands',
    text: '6000',
    smsCost: 126.0,
    smsCostWithoutVat: 105.0,
    smsCostIncVat: 151.2, // inc VAT
    checked: false,
  },
];

export const US_BUNDLES = (t) => [
  {
    id: '1',
    label: t('composite.purchaseSmsCreditDialog.bundles.small'),
    smsValue: 50,
    name: 'fifty',
    text: '150',
    smsCost: 3.5,
    smsCostWithoutVat: 3.0,
    smsCostIncVat: 4.2, // inc VAT
    checked: false,
  },
  {
    id: '2',
    label: t('composite.purchaseSmsCreditDialog.bundles.medium'),
    smsValue: 500,
    name: 'five_hundreds',
    text: '1500',
    smsCost: 35.0,
    smsCostWithoutVat: 30.0,
    smsCostIncVat: 42.0, // inc VAT
    checked: false,
  },
  {
    id: '3',
    label: t('composite.purchaseSmsCreditDialog.bundles.large'),
    smsValue: 2000,
    name: 'two_thousands',
    text: '6000',
    smsCost: 126.0,
    smsCostWithoutVat: 105.0,
    smsCostIncVat: 151.2, // inc VAT
    checked: false,
  },
];
